package com.anjuros.website.templates.template4.components

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.template4.styles.CompanyColorVar
import com.anjuros.website.templates.template4.modules.Template4Section
import com.anjuros.website.templates.template4.modules.Template4Theme
import com.anjuros.website.templates.template4.modules.getColor
import com.anjuros.website.templates.template4.styles.Template4NavigationItemStyle
import com.anjuros.website.templates.template4.util.Template4Constants
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Width
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template4Header(){
    val color = Template4Theme.Primary.getColor()
        Row(modifier = Modifier.displayIfAtLeast(Breakpoint.LG).margin(top=30.px).width(Width.FitContent),
            horizontalArrangement = Arrangement.spacedBy(40.px)) {
            Template4Section.entries.toTypedArray().forEach { section ->

                Column(modifier = Modifier) {
                    Link(
                        modifier = Modifier
                            .align(Alignment.CenterHorizontally)
                            .textDecorationLine(TextDecorationLine.None),
                        path = section.path
                    ) {
                        P(
                            attrs = Template4NavigationItemStyle.toModifier()
                                .setVariable(CompanyColorVar,color)
                                .margin(topBottom = 0.px)
                                .fontFamily(Template4Constants.FONT_FAMILY)
                                .fontSize(18.px)
                                .fontWeight(FontWeight.Normal)
                                .toAttrs()
                        ) {
                            Text(LocalText(section.title))

                        }
                    }
                }
            }
        }
}